const calculateUnits = (data) => {
  const { units_consumed, meter_start_at, meter_stop_at } = data;
  if (units_consumed >= 0) return units_consumed / 1000;
  else if (meter_start_at && meter_stop_at && meter_stop_at > meter_start_at)
    return (meter_stop_at - meter_start_at) / 1000;
  else {
    return 0;
  }
};

const findPrice = (data, station) => {
  return data.power_type === "AC"
    ? station.price_per_unit_ac
    : station.price_per_unit_dc;
};

const calculateItemStats = (
  item,
  units_consumed,
  station,
  is_fleet = false
) => {
  const electricityTotal =
    units_consumed * (station.price_per_unit_electricity ?? 0);
  const revenueTotal = is_fleet
    ? units_consumed * findPrice(item, station)
    : item.total_amount_spent;
  const profit = revenueTotal - electricityTotal;
  let companyProfit = 0;
  if (station.is_profit_sharing) {
    if (station.profit_sharing_type === "Fixed")
      companyProfit = units_consumed * station.profit_sharing_amount;
    else companyProfit = (profit * station.profit_sharing_amount) / 100;
  }
  return {
    electricityTotal,
    revenueTotal,
    profit: profit - companyProfit,
    companyProfit,
    withoutCompanyProfit: profit,
  };
};

export const generateTotalRevenue = (data, stationList) => {
  let units_consumed = 0;
  let electricity_total = 0;
  let company_profit = 0;
  let profit = 0;
  let withoutCompanyProfit = 0;
  let units_consumed_ac = 0;
  let units_consumed_dc = 0;
  const results = data.reduce((acc, item) => {
    const station = stationList.find(
      (itemm) => item?.facility_id === itemm?.id
    );
    if (item.is_fleet) {
      const itemUnits = calculateUnits(item);
      const stats = calculateItemStats(item, itemUnits, station, true);
      if (item?.power_type === "AC") units_consumed_ac += itemUnits;
      else units_consumed_dc += itemUnits;
      units_consumed += itemUnits;
      electricity_total += stats.electricityTotal;
      withoutCompanyProfit += stats.withoutCompanyProfit;
      company_profit += stats.companyProfit;
      profit += stats.profit;
      return acc + stats.revenueTotal;
    } else {
      const itemUnits = item?.units_consumed / 1000;
      const stats = calculateItemStats(item, itemUnits, station);
      units_consumed += itemUnits;
      electricity_total += stats.electricityTotal;
      company_profit += stats.companyProfit;
      withoutCompanyProfit += stats.withoutCompanyProfit;
      profit += stats.profit;
      return acc + stats.revenueTotal;
    }
  }, 0);
  units_consumed_ac = units_consumed_ac?.toFixed(2);
  units_consumed_dc = units_consumed_dc?.toFixed(2);
  return {
    revenue: results,
    electricity_total,
    company_profit,
    profit,
    units_consumed,
    units_consumed_ac,
    units_consumed_dc,
    withoutCompanyProfit,
  };
};
